import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, AppConfig } from '../app-config';
import { generateCodeChallenge, generateCodeVerifier } from './pkce-utils';

@Injectable({ providedIn: 'root' })
export class OAuthService {
  public clientId: string;
  public redirectUri: string;
  public authUrl: string;
  public scope: string;
  public tokenUrl: string;

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {
    this.clientId = config.clientId;
    this.redirectUri = config.redirectUri;
    this.authUrl = config.authUrl;
    this.scope = config.scope;
    this.tokenUrl = config.tokenUrl;
  }

  async loginWithPKCE(): Promise<void> {
    // Wait for config to be loaded
    while (!this.clientId || !this.redirectUri || !this.authUrl) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }

    const codeVerifier = generateCodeVerifier();
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    sessionStorage.setItem('pkce_code_verifier', codeVerifier);

    var ParamTax = sessionStorage.getItem('ParamTax');
    var lang = sessionStorage.getItem('lang');
    var token = sessionStorage.getItem('token');

    const stateObj = {
      lang: lang,
      ParamTax: ParamTax,
      token: token,
      nonce: crypto.randomUUID()
    };

    const url = `${this.authUrl}?response_type=code&client_id=${encodeURIComponent(this.clientId)}&redirect_uri=${encodeURIComponent(this.redirectUri)}&scope=${encodeURIComponent(this.scope)}&code_challenge=${encodeURIComponent(codeChallenge)}&code_challenge_method=S256&state=${encodeURIComponent(JSON.stringify(stateObj))}`;

    window.location.href = url;
  }
  
  async refreshAccessToken(): Promise<void> {
    const refreshToken = sessionStorage.getItem('refresh_token');

    // Wait for config to be loaded
    while (!this.clientId || !this.tokenUrl) {
      await new Promise(resolve => setTimeout(resolve, 50));
    }

    if (!refreshToken) {
      console.error('No refresh token found.');
      return;
    }

    // Manually build the form body to avoid encoding refresh_token
 const formData = new FormData();
  formData.append('grant_type', 'refresh_token');
  formData.append('client_id', this.clientId);
  formData.append('refresh_token', refreshToken);

    
    this.http
      .post(this.tokenUrl, formData)
      .subscribe((tokenResponse: any) => {
        // Save new tokens
        if (tokenResponse.access_token) {
        sessionStorage.setItem('access_token_oauth', tokenResponse.access_token);
        }
        if (tokenResponse.refresh_token) {
          sessionStorage.setItem('refresh_token', tokenResponse.refresh_token);
        }
        // Optionally, reload or navigate as needed
      }, error => {
        console.error('Failed to refresh token', error);
      });
  }

}
